import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styles from './copy-link.styl'
import { notification } from 'redux/modules/app'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'

@connect(
  () => ({}),
  { notification }
)
export default class CopyLink extends Component {
  static propTypes = {
    text: PropTypes.string,
    showText: PropTypes.bool
  }
  static defaultProps = {
    text: '',
    showText: false
  }

  copyToClipboard = text => {
    const el = document.createElement('textarea')

    const shortenText = text.length > 30 ? text.substring(0, 30) + '...' : text

    el.value = text
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    this.props.notification(<FormattedMessage
      id="label.copy_to_clipboard"
      defaultMessage="{text} was copied to the clipboard."
      values={{ text: shortenText }}
    />)
    document.body.removeChild(el)
  }

  render () {
    const { text, showText } = this.props

    if (showText) {
      return (
        <div className={`${styles.wrapper}`}>
          <div className={`${styles.text}`}>{text}</div>
          <div className={`${styles.icon}`}><div className={`${styles.link}`}><Link onClick={() => this.copyToClipboard(text)}><span
            className={`${styles.icon} ico ico--link-solid`} /></Link></div></div>
        </div>

      )
    } else {
      return (<div className={`${styles.link}`}><Link onClick={() => this.copyToClipboard(text)}><span
        className={`${styles.icon} ico ico--link-solid`} /></Link></div>)
    }


  }
}
